// import { useEffect } from 'react'
import Footer from 'components/layout/footer'
import styled from 'styled-components'
// import { useIsPolygon } from 'hooks/useEnvConfig'
import { STATICS } from '../../static'

function Index() {
  // const isPolygon = useIsPolygon()

  // useEffect(() => {
  //     if (isPolygon) {
  //         document.body.style.background = `url(${Polygon_STATICS.Polygon_bg}) no-repeat center center`
  //         document.body.style.backgroundSize = 'cover'
  //     }

  //     return () => {
  //         document.body.style.background = ''
  //         document.body.style.backgroundSize = 'auto'
  //     }
  // }, [isPolygon])

  return (
    <HomeWrapper>
      <LogoWrap>
        <img className="logo-cocos" alt="" src={STATICS.CocosLogo} />
        <img className="change" alt="" src={STATICS.Change} />
        <img className="logo-combo" alt="" src={STATICS.ComboLogo} />
      </LogoWrap>
      <Title1>Cocos-BCX revamps as COMBO in a branding upgrade to usher in a new era of Web3 game innovation.</Title1>
      <Title2>
        A top Web3 gaming Layer2 provider, offering open-source, decentralized Scaling Solutions for Game developer.
      </Title2>
      <EnterBtn onClick={() => {
        window.open('https://combonetwork.io/')
      }}>ENTER</EnterBtn>
      {/* <HomeContentWrapper bg={''}> */}

      {/* <HeadTitle titleColor={isPolygon ? '#fff' : '#00f4e4'}>
                    <span>The Ultimate </span>
                    <br />
                    GameFi Enabler
                </HeadTitle>
                <DescText>
                    Cocos-BCX aims to bridge more creators into crypto world via GameFi incubation, investment, distribution, IGO
                    and community, bringing high-quality GameFi projects for community users constantly.
                </DescText> */}
      {/* </HomeContentWrapper> */}
      <Footer />
    </HomeWrapper>
  )
}

export default Index

const HomeWrapper = styled.div`
  width: 816px;
  position: relative;
  margin: 13% auto 0;
`

const LogoWrap = styled.div`
  width: 100%;
  height: 90px;
  display: flex;
  justify-content: center;
  align-items: center;
  .logo-cocos {
    height: 90px;
  }
  .change {
    width: 24px;
    height: 24px;
    margin-left: 66px;
    margin-right: 77px;
  }
  .logo-combo {
    height: 44px;
  }
`

const Title1 = styled.p`
  width: 100%;
  margin-top: 39px;
  font-size: 16px;
  color: #ffffff;
  display: flex;
  justify-content: center;
  align-items: center;
`
const Title2 = styled.p`
  width: 100%;
  margin-top: 12px;
  font-size: 14px;
  color: #97c3f4;
  display: flex;
  justify-content: center;
  align-items: center;
`

const EnterBtn = styled.p`
  cursor: pointer;
  width: 210px;
  height: 40px;
  margin: 50px auto 0;
  border: 1px solid #c1c1c1;
  font-size: 16px;
  color: #ffffff;
  display: flex;
  justify-content: center;
  align-items: center;
`
// const HomeContentWrapper = styled.div<{ bg: string }>`
//   width: 100%;
//   height: 100%;
// `

// const HeadTitle = styled.h1<{ titleColor: string }>`
//   font-size: 60px;
//   font-weight: bold;
//   color: #fff;
//   width: 576px;
//   line-height: 76px;
//   position: relative;
//   top: 169px;
//   left: 88px;
//   span {
//     color: ${({ titleColor }) => titleColor};
//   }
// `

// const DescText = styled.p`
//   width: 559px;
//   color: #fff;
//   line-height: 28px;
//   position: relative;
//   left: 88px;
//   top: 169px;
//   margin-top: 23px;
// `
